export default "__VITE_ASSET__CWXfgVwR__"